import dateFns from 'date-fns'

import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppTextMask from '../app-text-mask'

export default
{
    name: 'app-resume',

    components:
    {
        AppBtnShare,
        AppImgBg,
        AppTextMask
    },

    watch:
    {
        contentPage: '_sortNews'
    },

    props:
    {
        type: { type: Number },
        category: { type: String },
        date: { type: Number, default: 0 },
        link: { type: String },
        cover: { type: String },
        title: { type: String },
        text: { type: String },
        footer: { type: String },
        share: { type: Object },
        isVideo: { type: Boolean, default: false },
        showCategoryAndDate: { type: Boolean, default: true }
    },

    methods:
    {
        getFormatDate(timestamp)
        {
            if (timestamp <= 0)
            {
                return ''
            }

            return dateFns.format(timestamp * 1000, 'DD[.]MM[.]YYYY [—] h[:]mm[<sup>]a[</sup>]')
        },

        _shorten(text, length)
        {
            if (text.length > length)
            {
                text = text.substr(0, length - 3)
                text = text.substr(0, Math.min(text.length, text.lastIndexOf(' '))) + '...'
            }

            return text
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-resume/script.js